const resources = {
  "en": {
    "status": {
      "task": {
        "pending": "Pending",
        "overdue": "Overdue",
        "manualExpense": "Manual expense",
        "recurrentIncome": "Recurring income",
        "accountPayment": "Account payment",
        "debtPayment": "Debt payment",
        "liabilityPayment": "Liability payment",
        "generic": "Task"
      },
      "deadline": {
        "overdue": "Overdue",
        "dueToday": "Due today",
        "dueSoon": "Due soon",
        "scheduled": "Upcoming",
        "noDate": "No due date"
      },
      "priority": {
        "high": "High priority",
        "normal": "Normal priority",
        "low": "Low priority"
      }
    }
  },
  "uk": {
    "status": {
      "task": {
        "pending": "Очікує",
        "overdue": "Прострочено",
        "manualExpense": "Ручна витрата",
        "recurrentIncome": "Регулярний дохід",
        "accountPayment": "Платіж по рахунку",
        "debtPayment": "Погашення боргу",
        "liabilityPayment": "Платіж за зобов'язанням",
        "generic": "Задача"
      },
      "deadline": {
        "overdue": "Прострочено",
        "dueToday": "Сьогодні",
        "dueSoon": "Невдовзі",
        "scheduled": "Заплановано",
        "noDate": "Без дати"
      },
      "priority": {
        "high": "Високий пріоритет",
        "normal": "Звичайний пріоритет",
        "low": "Низький пріоритет"
      }
    }
  }
};

export default resources;
